import { General } from "../../../../siteManagement/general.js";
import { SheetEventType } from "../../../../siteManagement/sheet.js";
import { Config } from "../../config/config.js";
import { Helper } from "../../util/helper.js";
import React from "react";
import axios from "axios";

export interface MatrixParams {
    RessNrs?: string[],
    RequiredSkills?: any[],
    IsAvailibilityFilterActive?: boolean,
    AssignmentGuids?: string[],
    Start?: Date,
    End?: Date
    MatchAllRequirementsActive?: boolean
}

export class SkillsMatrix extends React.Component<{
    isWindow: boolean;
}, {
    matrixParams: MatrixParams;
    gridData: any[];
}> {

    private magicDelphiDBDateNull = new Date(1899, 12, 30);

    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            matrixParams: {}
        }
    }

    private shouldUpdate = false;
    shouldComponentUpdate() {
        return this.shouldUpdate;
    }

    public updateMatrix = (gridData: any[], params: MatrixParams) => {
        this.shouldUpdate = true;
        this.setState({ gridData: gridData, matrixParams: params }, () => {
            this.shouldUpdate = false;
        });
    }

    public filterMatrix = (ressNrs: string[]) => {
        let gridData = this.state.gridData;
        if (gridData) {
            let filteredGridData = gridData.filter(x => ressNrs.includes(x.RessNr));
            this.shouldUpdate = true;
            this.setState({ gridData: filteredGridData }, () => {
                this.shouldUpdate = false;
            });
        }
    }

    private _notFulfilled = (row, idx) => {
        return row.Skills[idx] <= 0;
    }

    private _partiallyFulfilled = (row, idx) => {
        if (this.state.matrixParams.RequiredSkills.length == 0)
            return false;
        return row.Skills[idx] < this.state.matrixParams.RequiredSkills[idx].Wert;
    }

    private _fulfilled = (row, idx) => {
        if (this.state.matrixParams.RequiredSkills.length == 0)
            return true;
        return row.Skills[idx] >= this.state.matrixParams.RequiredSkills[idx].Wert;
    }

    private _getCellClass = (row, index) => {
        if (this._notFulfilled(row, index)) {
            return "k-bg-error";
        } else if (this._partiallyFulfilled(row, index)) {
            return "k-bg-warning";
        } else if (this._fulfilled(row, index)) {
            return "k-bg-success";
        }
        return null;
    }

    private _matrixEmpty = () => {
        return !Helper.hasValue(this.state.gridData) || this.state.gridData.length == 0;
    }

    handleResourceSelection = (ressNr) => {
        if (this.props.isWindow === true) {
            const sheet = General.Sheet.Manager.getTopMostSheet();
            sheet.trigger(SheetEventType.RowClicked, ressNr);
            sheet.trigger(SheetEventType.ItemsSelected, { data: [{ ressnr: ressNr }] });
            sheet.hide();
        } else {
            window.location.href = Config.baseUrl + "Resource/Edit?id=" + encodeURIComponent(ressNr);
        }
    }

    private downloadExcel = async () => {
        let response = await axios.post(
            Config.baseUrl + "Skills/GetMatrixExcelFile",
            {
                "matrix": this.state.gridData,
                "p": this.state.matrixParams
            },
            {
                responseType: "blob"
            });

        Helper.download(URL.createObjectURL(response.data), "matrix");
    }

    render() {
        if (this._matrixEmpty())
            return <p className="resourceSearchSkillsMatrix--message"> {Helper.getTranslation("Standard.Msg.KeineErgebnisse")}</p>;

        return (
            <div className="resourceSearchSkillsMatrix">
                <div className="innoToolBarWrapper">
                    <button className="k-button" onClick={this.downloadExcel} title={Helper.getTranslation("WebSMS.GeneralSettings.Units.DownloadAsExcel")}>
                        <i className="fal fa-file-download fa-fw fa-2x"></i>
                        {Helper.getTranslation("WebSMS.GeneralSettings.Units.DownloadAsExcel")}
                    </button>
                </div>
                <div className="resourceSearchSkillsMatrix__table k-grid-header k-grid-content k-grid" style={{ boxSizing: "border-box" }}>
                    <table id="matrixTable" className="k-grid-header-table k-table k-table-md" style={{ height: "fit-content" }}>
                        <thead className="k-table-thead">
                            <tr className="k-table-row">
                                <th className="k-table-th">{Helper.getTranslation("Field.Ressource.ressnr")}</th>
                                <th className="k-table-th k-header">{Helper.getTranslation("Field.Ressource.name")}</th>
                                <th className="k-table-th k-header">{Helper.getTranslation("Field.Ressource.gruppe")}</th>
                                <th className="k-table-th k-header">{Helper.getTranslation("Field.Ressource.obergruppe")}</th>
                                <th className="k-table-th k-header" style={{ textAlign: "right" }}>{Helper.getTranslation("WebSMS.WeeklyReport.Gesamt")} %</th>
                                {this.state.matrixParams.IsAvailibilityFilterActive ? <th className="k-table-th k-header" style={{ textAlign: "right" }}>{Helper.getTranslation("Standard.Zeit")} %</th> : null}
                                {
                                    this.state.matrixParams.RequiredSkills?.length > 0
                                        ? <th className="k-table-th k-header" style={{ textAlign: "right" }}>{Helper.getTranslation("Skills.Skill")} %</th>
                                        : null
                                }
                                {
                                    this.state.matrixParams.RequiredSkills?.map((column, idx) => {
                                        return <th className="k-table-th k-header" style={{ textAlign: "right" }} key={idx}>{column.Rtext}</th>;
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody className="k-table-tbody">
                            {
                                Array.isArray(this.state.gridData) ?
                                    this.state.gridData.map((row, idx) => {
                                        return (
                                            <tr className={"k-table-row k-master-row" + (idx % 2 !== 0 ? " k-alt k-table-alt-row" : "")} key={idx}>
                                                <td className="k-table-td">
                                                    {
                                                        this.props.isWindow ?
                                                            <a onClick={() => this.handleResourceSelection(row.RessNr)} style={{ cursor: "pointer" }}>{row.RessNr}</a>
                                                            :
                                                            <a href={Config.baseUrl + "Resource/Edit?id=" + encodeURIComponent(row.RessNr)}>{row.RessNr}</a>
                                                    }
                                                </td>
                                                <td className="k-table-td">{row.Name}</td>
                                                <td className="k-table-td">{row.Gruppe}</td>
                                                <td className="k-table-td">{row.Obergruppe}</td>
                                                <td className="k-table-td" style={{ textAlign: "right" }}>{row.DeckungGesamt}</td>
                                                {this.state.matrixParams.IsAvailibilityFilterActive ? <td className="k-table-td" style={{ textAlign: "right" }}>{row.DeckungZeit}</td> : null}
                                                {this.state.matrixParams.RequiredSkills?.length > 0
                                                    ? <td className="k-table-td" style={{ textAlign: "right" }}>{row.DeckungAnforderungen}</td>
                                                    : null
                                                }
                                                {
                                                    row.Skills?.map((s, sIdx) => {
                                                        let displayText: string = s.toString();
                                                        if (s > 9) {
                                                            //dirty
                                                            //große zahlen sind vermutlich datumswerte
                                                            let displayDate: Date = Helper.dates.addDays(this.magicDelphiDBDateNull, s);
                                                            displayText = displayDate.toLocaleDateString(kendo.culture().name, { month: '2-digit', day: '2-digit', year: 'numeric' });
                                                        }
                                                        return <td className={"k-table-td " + this._getCellClass(row, sIdx)} style={{ textAlign: "right" }} key={sIdx}>{displayText}</td>
                                                    })
                                                }
                                            </tr>
                                        );
                                    })
                                    : null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}